import { api } from '@/lib/api';

// ---- Dictation (speech-to-text) ----
// Records from the mic and transcribes via the backend (/api/stt). Nothing stored.
export function createRecorder() {
  let mediaRecorder = null;
  let chunks = [];
  let stream = null;

  return {
    async start() {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      chunks = [];
      const mime = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : '';
      mediaRecorder = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
      mediaRecorder.ondataavailable = (e) => { if (e.data.size) chunks.push(e.data); };
      mediaRecorder.start();
    },
    async stop() {
      return new Promise((resolve, reject) => {
        if (!mediaRecorder) return reject(new Error('not recording'));
        mediaRecorder.onstop = async () => {
          try {
            const blob = new Blob(chunks, { type: 'audio/webm' });
            stream?.getTracks().forEach(t => t.stop());
            const fd = new FormData();
            fd.append('audio', blob, 'speech.webm');
            const r = await api.post('/stt', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
            resolve(r.data.text || '');
          } catch (e) { reject(e); }
        };
        mediaRecorder.stop();
      });
    },
  };
}

// ---- Listen (text-to-speech) ----
let currentAudio = null;
export async function speak(text, voice = 'nova') {
  stopSpeaking();
  const r = await api.post('/tts', { text: String(text).slice(0, 4000), voice }, { timeout: 120000 });
  currentAudio = new Audio(r.data.audio);
  await currentAudio.play();
  return currentAudio;
}
export function stopSpeaking() {
  if (currentAudio) { try { currentAudio.pause(); } catch {} currentAudio = null; }
}
